'use strict'

import device from './device'
const JsBridgePlugin = {}

export function androidSetWebViewJavaScriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', () => {
      console.log('WebViewJavascriptBridgeReady事件回调了')
      callback(window.WebViewJavascriptBridge)
    }, false)
  }
  return
}

export function iosSetupWebViewJavaScriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement('iframe')

  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function timeCB() {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

JsBridgePlugin.install = function install(Vue, option) {
  Vue.prototype.$jsBridge = {
    registerHandler: () => (console.error('jsBridge初始化失败')),
    callHandler: () => { console.error('jsBridge初始化失败') }
  }
  if (device.webView) {
    if (device.android) {
      androidSetWebViewJavaScriptBridge(function androidCB(bridge) {
        Vue.prototype.$jsBridge = bridge
        console.log('初始化$jsBridge' + (typeof bridge.registerHandler === 'function'))
        option.callback(bridge)
      })
    } else if (device.ios) {
      iosSetupWebViewJavaScriptBridge(function iosCB(bridge) {
        Vue.prototype.$jsBridge = bridge
        console.log('初始化$jsBridge' + (typeof bridge.registerHandler === 'function'))
        option.callback(bridge)
      })
    }
  }
}
export default JsBridgePlugin


let func = () => {
  console.log()
}

if (device.webView()) {
  if (device.android) {
    func = androidSetWebViewJavaScriptBridge
  } else if (device.ios) {
    func = iosSetupWebViewJavaScriptBridge
  }
}

export const setJsBridge = func
